<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <span *ngIf="$.row && $.adata.fetch_key;else empty">{{getMode( $.row[$.adata.fetch_key])}}</span>
  <ng-template #empty>--</ng-template>
  
  </ng-container>